import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';
import { Box, IconButton, Tab, Table, TableCell, TableHead, TablePagination, TableRow, Tabs, Tooltip } from "@mui/material";
import { Button, Drawer, Stack, TextField } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function CustomerDetail({ open, currentRow, onClose }: { open: boolean; currentRow: any; onClose: any }) {
    const [openDrawer, SetOpenDrawer] = React.useState<any>(false);
    //const [data, SetData] = React.useState([] as any);
    const [customer, SetCustomer] = React.useState([] as any);
    const [currentTime, SetCurrentTime] = React.useState([] as any);
    const [licenses, SetLicenses] = React.useState([] as any);
    //const licenses = [] as any;

    function CreateLicenses(InfinityLicensing: string) {
        //alert(InfinityLicensing);
        let __licenses = [] as any;
        let _licenses = InfinityLicensing.replaceAll('<br>', ',').split(',');
        _licenses.forEach((license) => {
            let x = license.split(': ');
            if (x[0].trim() == 'Codis') return;
            if (x[1].trim() == 'True' || x[1].trim() == 'False') {
                __licenses.push({ Type: "Check", License: x[0], value: x[1].trim() == 'True' ? true : false })
            }
            else {
                __licenses.push({ Type: "Text", License: x[0], value: x[1] })
            }
        });
        SetLicenses(__licenses.sort(SortByLicense));
    }

    function SaveLicense(row: any, event: any) {
        var data_filter = licenses.filter((x: any) => x.License === row.License);
        data_filter[0].value = event.target.checked;
        SetCurrentTime(new Date().toString());
    }

    function SortByLicense(x: any, y: any) {
        return ((x.License == y.License) ? 0 : ((x.License > y.License) ? 1 : -1));
    }

    function GetLicenses(xtype: string, licensedValue: any): any {
        if (licensedValue != null) {
            var data_filter = licenses.filter((x: any) => x.Type === xtype && x.value == licensedValue);
        }
        else {
            var data_filter = licenses.filter((x: any) => x.Type === xtype);
        }
        return data_filter;
    }

    React.useEffect(() => {
        if (open) {
            // alert(currentRow);
            //alert(currentRow.CustomerId);
            let obj: any = new Object();
            obj.QueryType = "CustomerDetail";
            obj.CustomerId = currentRow.CustomerId;
            let jsonString = JSON.stringify(obj);
            let url = "http://csars-cssdata:5111/api/Infinity/" + jsonString;
            //alert(url);



            fetch(url)
                .then(response => (
                    response.json()
                ))
                .then(data =>
                (
                    SetCustomerData(data)

                )

                ).catch(
                    error => (alert('Error: ' + error)
                    )
                );

        }
    }, [open]);

    React.useEffect(() => {
        // alert('currentTime');
        // alert(customer.CustomerTypeCode);

    }, [currentTime]);

    function ApplyChanges() {
        SetCurrentTime(new Date().toString());

    }

    function SetCustomerData(data: any) {
        if (data.length > 0) {
            SetCustomer(data[0]);
            CreateLicenses(data[0].InfinityLicensing);
        }


    }


    function SaveChanges() {
        let jsonString = JSON.stringify(customer);
        alert(jsonString);
    }
    // const GetLicenses = (licenses: string) => {
    //     licenses = licenses.replaceAll('<br>', ',');
    //     return licenses.split(',');
    // }


    return (
        <Box display="flex"  >

            <Drawer
                PaperProps={{ style: { width: 'auto', maxWidth: "90%" } }}
                anchor="right"
                open={open}
                onClose={() => onClose(0)}
                variant={'temporary'}
            >
                <Box style={{ width: "100%", backgroundColor: "#1F618D", padding: "10px 0px" }}>
                    <Box style={{ marginLeft: "10px", color:"white", fontWeight:"bolder" }}>
                        {currentRow.CustomerName} ({currentRow.SystemID})

                    </Box>

                </Box>

                {/* <DrawerToolbar title={"Error Detail: " + row.ErrorId} onClose={() => onClose(0)} /> */}
                <Box style={{ margin: "5px 10px" }}>
                    <div style={{ position: "fixed", top: "5px", right: "25px" }}>
                        <Button size='small' variant="contained" onClick={() => SaveChanges()} endIcon={<CloseIcon />}>
                            Save Changes
                        </Button>
                        <Button style={{ marginLeft: "10px" }} size='small' variant="contained" onClick={() => onClose(0)} endIcon={<CloseIcon />}>
                            Close
                        </Button>

                    </div>
                    <table>
                        <tr>
                            <td valign='top'>
                                <fieldset style={{ padding: "5px 15px", border: "1px solid silver" }} >
                                    <legend>General</legend>

                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Company Name"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.CustomerName}
                                            onChange={(event) => { customer.CustomerName = event.target.value; ApplyChanges() }}
                                            size="small"
                                            style={{ width: "300px" }}
                                        />
                                    </Box>

                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Contact Person"
                                            id="outlined-size-small"
                                            value={customer.ContactPerson}
                                            onChange={(event) => { customer.ContactPerson = event.target.value; ApplyChanges() }}
                                            size="small"
                                            style={{ width: "300px" }}
                                        />
                                    </Box>

                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Address"
                                            id="outlined-size-small"
                                            value={customer.Address}
                                            onChange={(event) => { customer.Address = event.target.value; ApplyChanges() }}
                                            size="small"
                                            multiline
                                            maxRows={4}
                                            style={{ width: "300px" }}

                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Email"
                                            id="outlined-size-small"
                                            value={customer.EmailAddress}
                                            onChange={(event) => { customer.EmailAddress = event.target.value; ApplyChanges() }}
                                            size="small"
                                            style={{ width: "300px" }}
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Phone"
                                            id="outlined-size-small"
                                            value={customer.Phone}
                                            onChange={(event) => { customer.Phone = event.target.value; ApplyChanges() }}
                                            size="small"
                                            style={{ width: "300px" }}
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "0px" }}>

                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                            <InputLabel id="demo-simple-select-standard-label">Type</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-standard-label"
                                                id="demo-simple-select-standard"
                                                value={customer.CustomerTypeCode}
                                                onChange={(event) => { customer.CustomerTypeCode = event.target.value; ApplyChanges() }}
                                                label="Type"
                                            >
                                                <MenuItem value={0}>Classic</MenuItem>
                                                <MenuItem value={1}>Infinity</MenuItem>
                                                <MenuItem value={3}>SoftBiz</MenuItem>
                                                <MenuItem value={4}>SoftPower</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Licensed Users"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.Users}
                                            onChange={(event) => { customer.Users = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Notes"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.Notes}
                                            onChange={(event) => { customer.Notes = event.target.value; ApplyChanges() }}
                                            size="small"
                                            style={{ width: "300px" }}
                                            multiline
                                            maxRows={4}
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Setup Date"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.SetupDate}
                                            onChange={(event) => { customer.SetupDate = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Installer"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.SetupUser}
                                            onChange={(event) => { customer.SetupUser = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>

                                    <Box style={{ paddingLeft: "10px" }}>
                                        <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }} onChange={(event) => { customer.InActive = event.target.checked; ApplyChanges() }} checked={customer.InActive ? true : false} />} label="Inactive" />
                                    </Box>
                                    <Box style={{ paddingLeft: "10px" }}>
                                        <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }} onChange={(event) => { customer.CreateConnectFile = event.target.checked; ApplyChanges() }} checked={customer.CreateConnectFile ? true : false} />} label="Create VPN File for Linux system" />
                                    </Box>
                                    <Box style={{ paddingLeft: "10px" }}>
                                        <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }} onChange={(event) => { customer.RestartService = event.target.checked; ApplyChanges() }} checked={customer.RestartService ? true : false} />} label="Update/Restart Infinity Service" />
                                    </Box>
                                    <Box style={{ paddingLeft: "10px" }}>
                                        <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }} onChange={(event) => { customer.GetFullBackup = event.target.checked; ApplyChanges() }} checked={customer.GetFullBackup ? true : false} />} label="Get Full Database backup" />
                                    </Box>
                                    <Box style={{ paddingLeft: "10px" }}>
                                        <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }} onChange={(event) => { customer.PingISAServer = event.target.checked; ApplyChanges() }} checked={customer.PingISAServer ? true : false} />} label="Ping ISA server when connected" />
                                    </Box>


                                </fieldset>




                            </td>
                            <td valign='top'>
                                <fieldset style={{ padding: "5px 15px", border: "1px solid silver" }} >
                                    <legend>VPN</legend>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="VPN Name"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.VPNName}
                                            onChange={(event) => { customer.VPNName = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Login"
                                            id="outlined-size-small"
                                            defaultValue={customer.VPNUsers}
                                            value={customer.VPNUsers}
                                            onChange={(event) => { customer.VPNUsers = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Password"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.VPNPassword}
                                            onChange={(event) => { customer.VPNPassword = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Password"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.IPAddress}
                                            onChange={(event) => { customer.IPAddress = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "15px" }}>
                                        <TextField
                                            label="Windows Login"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.WindowsLogin}
                                            onChange={(event) => { customer.WindowsLogin = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>

                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Windows Password"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.WindowsPassword}
                                            onChange={(event) => { customer.WindowsPassword = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>


                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Note"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.VPNNote}
                                            onChange={(event) => { customer.VPNNote = event.target.value; ApplyChanges() }}
                                            size="small"
                                            multiline
                                            maxRows={3}
                                            style={{ width: "300px" }}
                                        />
                                    </Box>

                                </fieldset>
                                <fieldset style={{ padding: "5px 15px", border: "1px solid silver" }} >
                                    <legend>Program Updates</legend>
                                    <Box style={{ paddingLeft: "10px" }}>
                                        <Tooltip arrow title={"Last Updated: " + customer.AutoUpdateChanged}>
                                            <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }} onChange={(event) => { customer.EnableAutoUpdate = event.target.checked; ApplyChanges() }} checked={customer.EnableAutoUpdate ? true : false} />} label="Automatic Program Updates" />
                                        </Tooltip>
                                    </Box>
                                    <Box style={{ paddingLeft: "10px" }}>
                                        <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }} onChange={(event) => { customer.AllowPriceUpdateOnly = event.target.checked; ApplyChanges() }} checked={customer.AllowPriceUpdateOnly ? true : false} />} label="Price Updates Only" />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Program Files Folder"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.ProgramFilesFolder}
                                            onChange={(event) => { customer.ProgramFilesFolder = event.target.value; ApplyChanges() }}
                                            size="small"
                                            multiline
                                            maxRows={3}
                                            style={{ width: "300px" }}
                                        />
                                    </Box>
                                </fieldset>
                                <fieldset style={{ padding: "5px 15px", border: "1px solid silver" }} >
                                    <legend>Database</legend>

                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Database Server"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.DatabaseServerName}
                                            onChange={(event) => { customer.DatabaseServerName = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Database Nmae"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.DatabaseName}
                                            onChange={(event) => { customer.DatabaseName = event.target.value; ApplyChanges() }}
                                            size="small"
                                        />
                                    </Box>
                                    <Box style={{ marginTop: "10px" }}>
                                        <TextField
                                            label="Copy Database Backup Folder"
                                            id="outlined-size-small"
                                            // defaultValue="Small"
                                            value={customer.CopyDBBackupTo}
                                            onChange={(event) => { customer.CopyDBBackupTo = event.target.value; ApplyChanges() }}
                                            size="small"
                                            multiline
                                            maxRows={4}
                                        />
                                    </Box>
                                </fieldset>
                            </td>
                            <td valign='top'>

                                <Box style={{ margin: "0px 3px" }}>
                                    <fieldset style={{ padding: "5px 15px", border: "1px solid silver" }} >
                                        <legend>Licenses</legend>
                                        <table>
                                            <tr>
                                                <td valign='top'>
                                                    {GetLicenses('Check', true).map((row: any, index: any) => {
                                                        return (
                                                            <Box>
                                                                <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }}
                                                                    checked={row.value ? true : false} />}
                                                                    onChange={(event) => { SaveLicense(row, event) }}
                                                                    label={row.License} />

                                                            </Box>
                                                        )
                                                    })}
                                                    <Box style={{ border: "1px solid silver", marginTop: "15px", padding: "5px 10px" }}>
                                                        {GetLicenses('Text', null).map((row: any, index: any) => {
                                                            return (
                                                                <Box style={{ padding: "0px", margin: "0px" }}>
                                                                    {row.License}: [{row.value}]

                                                                </Box>
                                                            )
                                                        })}
                                                    </Box>


                                                </td>
                                                <td valign='top'>
                                                    <Box style={{ marginLeft: "20px" }} >
                                                        {GetLicenses('Check', false).map((row: any, index: any) => {
                                                            return (
                                                                <Box >
                                                                    <FormControlLabel control={<Checkbox style={{ padding: "0px", paddingRight: "5px" }}
                                                                        checked={row.value ? true : false} />}
                                                                        onChange={(event) => { SaveLicense(row, event) }}
                                                                        label={row.License} />

                                                                </Box>
                                                            )
                                                        })}
                                                    </Box>

                                                </td>

                                            </tr>
                                        </table>
                                    </fieldset>
                                </Box>


                            </td>

                        </tr>
                    </table>

                </Box>


            </Drawer >


        </Box >

    )
}